<template>
  <div class="after_order">
    <!-- 增加头部导航栏 -->
    <van-sticky>
      <van-tabs class="div-tab" :border="false" :active="active" @change="onChange" :ellipsis="false" >
        <van-tab title="全部" name="ALL_ORDER"></van-tab>
        <van-tab title="待审核"  :info="num.waitCheckCount==0?'':num.waitCheckCount" name="WAIT_CHECK"></van-tab>
        <van-tab title="处理中"  :info="num.returningCount==0?'':num.returningCount" name="RETURN_ING"></van-tab>
        <van-tab title="已完成" name="FINISH"></van-tab>
      </van-tabs>
      <div class="tab-sx">
        <div class="item">
          <van-field class="tex" v-model="returnCodeLike" placeholder="输入售后单号查询" />
          <van-button icon="search" class="btn" @click="serchFun"></van-button>
        </div>
        <div class="dv2">
          <FilterItem class="" :display="displayIcon" @onClick="clickTimeIcon" :onFixed="false" height="70"></FilterItem>
        </div>
      </div> 
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
      >
      <afterOrderItem 
        ref="orderItems" 
        v-for="(item,index) in list" :key="index" 
        :index="index"
        :item="item" 
        :type="'beeafterorder'" 
        @getonlode= 'getonlode'
        @change="i => orderItemIndex = i"
      />
      </van-list>
    </van-pull-refresh>
  </div> 
</template>
<script>
import afterOrderItem from "./components/afterorderitemnew";
import FilterItem from "@/components/filter/item";
import http from "@/utils/axios";
export default {
  data() {
    return {
       num: {
        returningCount: "",
        waitCheckCount: "",
      },
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      error: false,

      active:'RETURN_ING',
      searchval:'',  //输入的单号
      displayIcon:{
        one: {show:false},
        two: {show:false},
        three:{showIcon:true, name:'时间',key:'down', actived:false},
        four:{active:false},
      },
      returnCodeLike:'',//售后单号,
      orderByTime:'desc',   //时间的筛选
      urgeStatus:0,  //催单状态  0 不勾选 1 勾选
      status:'', // 售后状态   WAIT_CHECK 待审核 RETURN_ING 处理中 FINISH 已完成
      queryBranchType:0, // 店铺类型 0 1 2
      orderItemIndex: 0
    };
  },
  methods: {
    isPrintTieckt() {
      if (window.navigator.userAgent.indexOf('client-info') > -1) {
          let b = window.navigator.userAgent;
          b = b.split('client-info=')[1];
          let c = JSON.parse(b);
          let user_id = c.user_id || '';
          if (user_id) {
            http({
              url: "order/admin/express/printConfig/" + user_id,
              method: "GET",
              parmes: {}
            }).then(res => {
              if (res.code == 200) {
                let isEnableTicket = res.data.isEnableTicket || '禁用'
                localStorage.setItem('isEnableTicket',isEnableTicket)
              }
            })
          }
      }else {
        localStorage.setItem('isEnableTicket','禁用')

      }
    },
    // 点击头部切换
    onChange(tab) {
      this.active = tab;
      let idx = 0;
      this.orderByTime = 'desc'
      this.displayIcon['three'].key='down'
      this.returnCodeLike = ''
      switch (tab) {
        case "ALL_ORDER":
          idx = 0;
          break;
        case "JUST_MONEY":
          idx = 1;
          break;
        case "JUST_PRODUCT":
          idx = 2;
          break;
        default:
          idx = 3;
          break;
      }
     
      console.log('tab',tab)
      this.$loading.hide();
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.getUrl(tab);
    },
    getUrl(tab){
      this.status = tab;
      this.serchFun();
    },

    // 售后单号查询
    serchFun(){
        this.pageNum = 1;
        this.finished = false;
        this.loading = true;
        this.list= [];
        this.onLoad();
    },
    // 右侧筛选框
    clickTimeIcon(val){
      console.log("clickTimeIcon -> val", val)
      if(val.type == 'four'){
        this.$filterDrawer({
          visibleTimerInput: false,
          visiblePriceInput: false,
          list: [{
            name: '售后类型',
            type: 'other',
            alias: 'markRes',
            idKey: 'id',
            valueKey: 'value',
            // select: 'radio',
            data: [
              {id:'JUST_MONEY', value:'仅退款'},
              {id:'JUST_PRODUCT', value:'退款退货'},
              {id:'CHANGE_PRODUCT', value:'换货'},
              {id:'JUST_FREIGHT', value:'退运费'}
            ]
          },{
            name: '异常',
            type: 'other',
            alias: 'urge',
            idKey: 'key',
            valueKey: 'value',
            // select: 'radio',
            data: [
              {key:'1', value:'加急'},
            ]
          },
          {
              name: '店铺类型',
              type: 'other',
              alias: 'queryBranchType',
              idKey: 'key',
              valueKey: 'value',
              select: 'radio',
              data: [
                {key:1, value:'真实店铺'},
                {key:2, value:'影子店铺'},
              ]
            }
        
        ],
          confirm: res => {
            console.log("clickTimeIcon -> res", res)
            console.log("clickTimeIcon -> res", res)
            if(res.queryBranchType && res.queryBranchType.length > 0){
              this.queryBranchType = res.queryBranchType[0]
            }
            if(res.queryBranchType && res.queryBranchType.length == 0){
              this.queryBranchType = 0
            }
            //对备注入参赋值
            if(res.markRes && res.markRes.length > 0){
                  var afterTypeStr = '';
                	res.markRes.forEach(itme=>{
                    afterTypeStr += itme + ','
                  })
              this.afterTypeStr = afterTypeStr.substring(0, afterTypeStr.lastIndexOf(','));
            }
            if(res.markRes && res.markRes.length == 0){
              this.afterTypeStr = ''
            }
            if(res.urge && res.urge.length > 0){
              this.urgeStatus = 1;
            }else{
              this.urgeStatus = 0;
            }
            //对时间入参赋值
            // res.start ? (this.startTime = res.start.time) : (this.startTime = '')
            // res.end ? (this.endTime = res.end.time) : (this.endTime = '')
            this.displayIcon['four'].active = res.state
            this.serchFun()
          }
        })
      }
      if(val.type.indexOf('three')!=-1){
        val.type.indexOf('up') > 0 && (this.orderByTime = 'asc')
        val.type.indexOf('down') > 0 && (this.orderByTime = 'desc')
        this.refreshing = true
        this.serchFun()
      }
    },

    // 获取头部数量角标  /order/app/newafter/bees/countInfo
    beeCountInfo(){
      http({
        url: "/order/app/newafter/bees/countInfo",
        method: "get",
        parmes: {
        }
      })
        .then(rps => {
          if (rps.code == 200) {
            this.num = rps.data
          }
        })
    },

    getonlode(id){
      var list = this.list;
      list.forEach((itme,index)=>{
        if(id == itme.id){
          console.log(index);
          list.splice(index,1);
        }
      })
      this.list = list;
      this.beeCountInfo();
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      var parmes = {
          pageNum: this.pageNum,
          pageSize: 20,
          afterTypeStr: this.afterTypeStr,
          orderByTime:this.orderByTime,
          returnCodeLike:this.returnCodeLike,
          urgeStatus:this.urgeStatus,
          queryBranchType:this.queryBranchType // 影子店铺 0 1 2
          // status:this.status
      };
      if(this.status != 'ALL_ORDER'){
          parmes.status = this.status
      }
      http({
        url: "/order/app/newafter/bees/newPage",
        method: "post",
        parmes: parmes
      })
        .then(rps => {
          if (rps.code == 200) {
            this.error = false;
            this.loading = false;
            if (!rps.data || rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum++;
            }
            this.list = this.list.concat(rps.data.list);
            this.beeCountInfo();
          }
        })
        .catch(err => {
          this.error = true;
          this.loading = false;
          this.finished=false;
        });
    },
    onRefresh() {
      setTimeout(() => {
      this.pageNum = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
      }, 1000);
      
    }
  },
  created(){
    this.isPrintTieckt();
    this.$loading.hide();
    // this.beeCountInfo();
    this.active = 'WAIT_CHECK';
    this.status = 'WAIT_CHECK';
    // this.list = [];
    window["setVoucherImgKeys"] = (res) => {
      const item = this.$refs.orderItems[this.orderItemIndex]
      item.onUploadImageSuccess(res)
    };
  },
  components: { afterOrderItem,FilterItem },
};
</script>
<style lang="less" scoped>
    /deep/.van-tab van-ellipsis {
      flex-basis: 20%;
      flex: 0 0 20%;
    }
    /deep/.van-card__bottom {
      text-align: right;
    }
    /deep/.van-card__price .van-card__price-integer {
      font-size: 16px;
    }
    /deep/.van-card__thumb img {
      border-radius: 0;
    }
    /deep/.van-info {
      color: #f8a651;
      background: #fff;
      border: 1px solid #f8a651;
    }
    /deep/.van-tabs__line {
      background-color: var(--epButtonColor);
    }
    .div-tab span {
      color: #333;
    }
    .tab-sx {
      background-color: #ffffff;
      height: 72px;
      font-size: 24px;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      /deep/.van-cell{
        padding: 0;
      }
      /deep/.van-field__control {
        width: 413px;
        height: 60px;
        background: #F7F7F7;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        -webkit-appearance: none;
        padding-left: 20px;
        font-size: 20px;
      }
      input{
        -webkit-appearance: none;
      }
      .btn{
        width: 60px;
        height: 60px;
        background: var(--epButtonColor);
        color:var(--epTextColor);
        border-radius: 10px;
        margin-left: -3px;
      }
      .item {
        display: flex;
      }
      .dv2{
        width: 220px;
        // height: 70px;
      }
    }
</style>